import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Users } from './users.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {


  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {
  }

  Create(userObj: any) {
    return this.http.post(this.global.APIURL + "identity/registeradmin", userObj)
  }

  Update(userObj: any) {
    return this.http.put(this.global.APIURL + "users", userObj)
  }

  getWebUsers() {
    return this.http.get<Users[]>(this.global.APIURL + "users/getwebadminusers")
  }

  resetAdminPassword(obj: any) {
    return this.http.post<any>(this.global.APIURL + "identity/adminresetpassword", obj);
  }

  ChangeRole(obj: any) {
    return this.http.put<any>(this.global.APIURL + "identity/changerole", obj)
  }

  getUserById(id: string) {
    return this.http.post<any>(this.global.APIURL + "users/getbyid/" + id, null);
  }

  deleteUser(id: string) {
    return this.http.delete<any>(this.global.APIURL + "identity/delete/" + id);
  }

}
